import { Container } from './Modal.style';

const Modal = ({ open = true, children, style }) => {
  return (
    <Container open={open} style={style}>
      {children}
    </Container>
  );
};

export default Modal;
